import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { RemovableFreeFieldProfile } from "components/Removables/RemovableFreefieldProfile";
import React from "react";
import { ModalPickerProps } from "../props";
import FreefieldProfileList from "./FreefieldProfileList";

interface Props extends ModalPickerProps<server.dto.FreeFieldProfileSmall> {
  excludeProfiles?: number[];

  environment: server.dto.Environments;
}

const FreeFieldProfileModalPicker = (props: Props) => {
  const { excludeProfiles, ...rest } = props;

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={RESX.FreeField.FreeFieldPermissionProfile}
    modalSize="mini"

    renderModalContent={(closeModal) => <FreefieldProfileList
      excludeKeys={excludeProfiles}
      onItemSelected={(freefieldProfile) => {
        closeModal();
        props.onChange(freefieldProfile);
      }}
      environment={props.environment}
    />}
    renderRemovable={(props) => <RemovableFreeFieldProfile {...props} />}
    onChange={() => { props.onChange(undefined); }}
    {...rest}
  />;
};

export default FreeFieldProfileModalPicker;